import axios from "axios";

export const state = {
    insurancepatients: [],
};

export const getters = {
    insurancepatients: state => state.insurancepatients,
};

export const mutations = {
    setInsuranceVisits(state, newValue) {
        state.insurancepatients = newValue
    },
};

export const actions = {
    fetchInsuranceVisits({ commit }) {
        axios.get('/insurancepatients').then(res => {
            commit('setInsuranceVisits', res.data.insurancedpatients);
        })
    },
};
